<template>
  <div>
    <NavBarDSO />
  <div class="loader" id="buyLoader">
    <span class="helper" id="buyHelper"></span>
    <div id="buyTrans">
        <img src="../img/loader.gif" /><br>
        <a id="link" target="_blank">Track your transaction</a>
    </div>
</div>
    <div class="buy-wrapper">
      <h1 class="table-headline">Request Assets</h1>
      <div class="page-bubble qualifying-wrapper">
        <h3 class="table-headline">List of qualifying assets</h3>
        <table id="offersTable">
          <thead>
            <tr>
			<th>Asset Name</th>
            <th>Date From</th>
			<th>Date To</th>
			<th>Time From</th>
			<th>Time To</th>
            <th>Price</th>
            <th>Volume</th>
            <th>City</th>
			<th>When</th>
              <th class="table-check">
                <button class="select-all-button offer-search-button" v-on:click="selectAll">Select All</button>
              </th>
            </tr>
          </thead>
        </table>
        <div class="qualify-button-wrapper">
          <!--<button class="offer-remove-button">Back</button>-->
		<div>
        <button class="offer-add-button" @click="selectOffers">Select</button>
		<p>
		<span id="Order"></span><br>
		<span id="tot_price"></span><br>
		<span id="tot_volume"></span><br>
		<span id="actiavtion_fee"></span>
		</p>
		</div>		
          <button class="offer-add-button" @click="offerRequest">Proceed to Buy</button><br>
          <span/>
          <span id="actual"></span><br>
		      <span id="scheduled"></span><br>
           <div id="iot_chart" style="height: 300px; width: 100%;"> </div><br>
           <button class="offer-add-button" @click="finalPay" style="display:none" id="finalPayButton">Transfer</button><br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarDSO from "../components/Common/NavBarDSO";
export default {
  components: { NavBarDSO },
  methods: {
    selectAll() {
      let boxes = document.querySelectorAll("input");
      for (let box of boxes) {
        box.checked = true;
      }
    },
    offerRequest() {
      this.Apps.offerRequest();
    },
    selectOffers() {
      this.Apps.selectOffers();
    },
    finalPay() {
      this.Apps.finalPay();
    },
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #e6e8f0;
  min-height: 100vh
}
.qualifying-wrapper {
  width: 100%;
}
.select-all-button {
  margin: 0 auto;
}
.table-check {
  text-align: center !important;
}
.buy-wrapper table{
  width: 100%;
}
.buy-wrapper th {
  color: #4a4a4a;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}
.buy-wrapper td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}
.buy-wrapper tbody tr:hover {
  background: #f5f8fd;
}
button {
  margin: 20px 20px 0 0;
}
.load{
  display: none;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 200px; /* Location of the box */
  padding-left: 50%;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
}
.loader{
    background:rgba(0,0,0,.4);
    display:none;
    height:100%;
    position:fixed;
    text-align:center;
    top:0;
    width:100%;
    z-index:10000;
}
.loader .helper{
    display:none;
    height:40%;
    vertical-align:middle;
}
.loader > div {
    background-color: #fff;
    box-shadow: 10px 10px 60px #555;
    display: none;
    width: 20%;
    position: fixed;
    border-radius: 8px;
    padding: 15px 5%;
    margin-top:19%;
	margin-left:-10%;
}

.link:hover {
text-decoration:underline;
}
</style>
